import { useMemo } from "react";

// como no hay react-router o wouter
// se hizo asi, si se desea usar el useParams de las librerías se puede instalar
// pero como es solo una página lo veo innecesario
export function useToken() {
    const token = useMemo(() => {
        const params = new URLSearchParams(location.search)
        return params.get("id") ?? ""
    }, [])

    return [token] as const
}
